<template>
    <CarouselGrid class="job-page-profiles-list" :items="carouselItems">
        <template #slide="{item}">
            <ProfileCard v-if="item.id" :profile="formatProfile(item)" :link-href="$withLocalePrefix(item.url)" />
            <JobPageHelpCard v-else />
        </template>
    </CarouselGrid>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {ProfileCard} from '#components';
    import type {FreelancerProfile} from '@api';
    import CarouselGrid from '~/components/CarouselGrid.vue';
    import {formatProfile} from '~/composables/acquisition/useAcquisitionPage';
    import JobPageHelpCard from './JobPageHelpCard.vue';

    const {profiles} = defineProps<{profiles?: FreelancerProfile[]}>();

    const carouselItems = computed(() => {
        const data = [...(profiles as any)];
        data.splice(7, 0, {}); // help-card
        return data;
    });
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .job-page-profiles-list {
        .profile-card {
            height: 100%;
        }

        @include mq.screen_md {
            .swiper-slide {
                padding-bottom: var(--joy-core-spacing-3);
            }
        }
    }
</style>
